/**
 * @author TomaszCzura ({}
 */
import {combineReducers} from 'redux';
import * as types from '../actions/action-types';

// Reducers
import keyReducer from './key-reducer';
import userReducer from './user-reducer';
import siteReducer from './site-reducer';
import checkinReducer from './checkin-reducer';
import dashboardReducer from './dashboard-reducer';
import mobileUsersReducer from './mobile-user-reducer';
import transactionLogReducer from './transaction-log-reducer';
import developerReducer from './developer-reducer';
import roomReducer from './room-reducer';
import specialareaReducer from './specialarea-reducer';
import siteAgentLogsReducer from './site-agent-log-reducer';
import {reducer as toastrReducer} from 'react-redux-toastr';
import managementReducer from './management-reducer';
import managementTrackingReducer from './management-tracking-reducer';
import logsKeyCreationReducer from './log-reducer';

const reducers = combineReducers({
  keysState: keyReducer,
  usersState: userReducer,
  sitesState: siteReducer,
  checkinsState: checkinReducer,
  dashboardState: dashboardReducer,
  managementState: managementReducer,
  mobileUsersState: mobileUsersReducer,
  transactionLogsState: transactionLogReducer,
  managementTrackingState: managementTrackingReducer,
  developersState: developerReducer,
  roomsState: roomReducer,
  specialareasState: specialareaReducer,
  siteAgentLogsState: siteAgentLogsReducer,
  logsKeyCreationReducer: logsKeyCreationReducer,
  toastr: toastrReducer,
});

const rootReducer = (state, action) => {
  switch (action.type) {
    case types.USER_LOGOUT:
      state = undefined;
      break;
  }

  return reducers(state, action);
};

export default rootReducer;
